module.exports = __webpack_public_path__ + "img/pay-icon-12.40d79880.png";